<template>
  <div class="fm-grid">
    <div v-if="loadingSpinner">
      <loading :active.sync="showLoaderModal" :can-cancel="false"
                loader="dots" color="rgb(20, 80, 144)" :width="75"
        :is-full-page="false">
      </loading>
    </div>
    <div v-else-if="directories.length === 0 && files.length === 0">
      <div v-if="breadcrumb !== null">
        <div class="empty-state text-center" v-if="breadcrumb[0] === 'searchResult'">
          <i class="bx bx-search-alt mb-3"></i>
          <h5 class="mb-3">
            {{ $t("filemanager.location.search_result.title") }}
          </h5>
          <p>{{ $t("filemanager.location.search_result.text") }}</p>
        </div>
        <div class="empty-state text-center" v-else>
          <!-- {{"on passe la : " + breadcrumb}} -->
          <transition name="fade" appear>
            <div>
              <i class="bx bxs-file mb-3"></i>
              <h5 class="mb-3">{{ $t("filemanager.location.empty.title") }}</h5>
              <p>{{ $t("filemanager.location.empty.text") }}</p>
            </div>
          </transition>
          <button class="btn btn-light" v-on:click="showModal('Upload')">
            {{ $t("navbar.buttons.upload") }}
          </button>
        </div>
      </div>
      <div class="empty-state text-center" v-else>
        <!-- {{"on passe la : " + breadcrumb}} -->
        <transition name="fade" appear>
          <div>
            <i class="bx bxs-file mb-3"></i>
            <h5 class="mb-3">{{ $t("filemanager.location.empty.title") }}</h5>
            <p>{{ $t("filemanager.location.empty.text") }}</p>
          </div>
        </transition>
        <button class="btn btn-light" v-on:click="showModal('Upload')">
          {{ $t("navbar.buttons.upload") }}
        </button>
      </div>
    </div>
    <div class="table-responsive" v-else>
      <table class="table mt-2">
        <thead class="thead-light">
          <tr>
            <th class="w-65" v-on:click="sortBy('name')">
              {{ $t('filemanager.manager.table.name') }}
              <template v-if="sortSettings.field === 'name'">
                <i class="fas fa-sort-amount-down" v-show="sortSettings.direction === 'down'" />
                <i class="fas fa-sort-amount-up" v-show="sortSettings.direction === 'up'" />
              </template>
            </th>
            <th class="w-10" v-on:click="sortBy('owner')">
              {{ $t('filemanager.manager.table.owner') }}
              <template v-if="sortSettings.field === 'type'">
                <i class="fas fa-sort-amount-down" v-show="sortSettings.direction === 'down'" />
                <i class="fas fa-sort-amount-up" v-show="sortSettings.direction === 'up'" />
              </template>
            </th>
            <th class="w-10" v-on:click="sortBy('size')">
              {{ $t('filemanager.manager.table.size') }}
              <template v-if="sortSettings.field === 'size'">
                <i class="fas fa-sort-amount-down" v-show="sortSettings.direction === 'down'" />
                <i class="fas fa-sort-amount-up" v-show="sortSettings.direction === 'up'" />
              </template>
            </th>
            <th class="w-auto" v-on:click="sortBy('date')">
              {{ $t('filemanager.manager.table.date') }}
              <template v-if="sortSettings.field === 'date'">
                <i class="fas fa-sort-amount-down" v-show="sortSettings.direction === 'down'" />
                <i class="fas fa-sort-amount-up" v-show="sortSettings.direction === 'up'" />
              </template>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-row" style="cursor:pointer" v-for="(directory, index) in directories"
            v-bind:key="`d-${index}`" v-bind:class="{'active-row': checkSelect('directories', directory.path)}"
            v-on:click="selectItem('directories', directory.path, $event)" v-on:dblclick.stop="acl && directory.acl !== 0
                ? selectDirectory(directory.path)
                : diplayAccessMessage()
            " v-on:contextmenu.prevent.stop="acl && directory.acl !== 0 ? contextMenu(directory, $event) : false">
            <transition name="fade" appear>
              <td class="fm-content-item unselectable" v-bind:class="(acl && directory.acl === 0) ? 'text-hidden' : ''"
                v-on:dblclick="acl && directory.acl !== 0 ? selectDirectory(directory.path) : diplayAccessMessage()">
            
                <img width="30" class="mr-3" v-if="!directory.shared"
                  src="../../assets/folder.png" alt="">
                <img width="30" class="fm-folder-item mr-3" v-else
                  src="../../assets/shared.svg" alt="" />
                <span class="item-name">
                  {{ directory.basename }}
                </span>
                  <i class="share-button bx bxs-share-alt"></i>
              </td>
            </transition>
            <td>{{ directory.author }}</td>
            <td></td>
            <td>
              <!-- {{ $d(new Date(directory.timestamp), 'short') }} -->
            </td>
          </tr>
          <tr class="table-row" style="cursor:pointer" v-for="(file, index) in files" v-bind:key="`f-${index}`"
            v-bind:class="{'active-row': checkSelect('files', file.path)}"
            v-on:click="selectItem('files', file.path, $event)"
            v-on:dblclick="acl && file.acl !== 0 ? selectAction(file.path, file.extension) : diplayAccessMessage()"
            v-on:contextmenu.prevent.stop="acl && file.acl !== 0 ? contextMenu(file, $event) : false">
            <transition name="fade" appear>
              <td class="fm-content-item unselectable" v-bind:class="(acl && file.acl === 0) ? 'text-hidden' : ''">
                <img class="mr-3" v-if="file.extension === 'pdf'" width="30" src="../../assets/icons/pdf.png" alt="">
                <img class="mr-3" v-else-if="file.extension === 'doc' || file.extension === 'docx'" width="30"
                  src="../../assets/icons/word.svg" alt="">
                <img class="mr-3" v-else-if="thisImage(file.extension)" width="30" src="../../assets/icons/picture.png"
                  alt="">
                <img class="mr-3" v-else-if="file.extension === 'xls' || file.extension === 'xlsx'" width="30"
                  src="../../assets/icons/excel.svg" alt="">
                <img class="mr-3" v-else-if="file.extension === 'ppt' || file.extension === 'pptx'" width="30"
                  src="../../assets/icons/powerpoint.svg" alt="">
                <img class="mr-3" v-else-if="file.extension === 'mp3' || file.extension === 'wav'" width="30"
                  src="../../assets/icons/audio.png" alt="">
                <img class="mr-3" v-else-if="file.extension === 'mp4' || file.extension === 'mpeg'" width="30"
                  src="../../assets/icons/video.png" alt="">
                <!-- <i v-else class="far mr-3" style="font-size: 26px" v-bind:class="extensionToIcon(file.extension)" /> -->
                <img class="mr-3" v-else width="30" src="../../assets/icons/form.png" alt="">
                <span class="item-name">
                  {{ file.filename ? file.filename : file.basename }}
                </span>
              </td>
            </transition>
            <td>
              {{ file.author }}
            </td>
            <td>{{ bytesToHuman(file.size) }}</td>
            <td>
              <!-- {{ $d(new Date(file.timestamp), 'short') }} -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import helper from '../../router/mixins/helper';
import managerHelper from './mixins/manager';
import EventBus from "../eventBus";
import Loading from "vue-loading-overlay";

export default {
  name: 'table-view',
  mixins: [helper, managerHelper],
  components: { Loading },
  props: {
    manager: { type: String, required: true },
  },
  data() {
    return {
      showLoaderModal: false,
    };
  },
  computed: {
    /**
     * Sort settings
     * @returns {*}
     */
    sortSettings() {
      return this.$store.state.left.sort;
    },
    breadcrumb() {
      return this.$store.getters[`${this.manager}/breadcrumb`];
    },
    loadingSpinner() {
      return this.$store.state.messages.loading;
    },
    /**
     * Image extensions list
     * @returns {*}
     */
    imageExtensions() {
      return this.$store.state.settings.imageExtensions;
    },
  },
  created() {},
  updated() {
    // console.log("breadcrumb la : ", this.breadcrumb);
    if (this.directories.length > 0 || this.files.length > 0) {
      this.isLoading = false;
    }
    if (this.loadingSpinner > 0) {
      this.showLoaderModal = true;
    }
    if (this.loadingSpinner === 0) {
      this.showLoaderModal = false;
    }
  },
  methods: {
    diplayAccessMessage() {
      EventBus.$emit("addNotification", {
      status: "error",
      message: 'Accès refusé !',
      });
    },
    /**
     * Show modal window
     * @param modalName
     */
    showModal(modalName) {
      // show selected modal
      this.$store.commit("modal/setModalState", {
        modalName,
        show: true,
      });
    },
    /**
     * Sort by field
     * @param field
     */
    sortBy(field) {
      this.$store.dispatch(`${this.manager}/sortBy`, { field, direction: null });
    },
    /**
     * get Directory Type
     * @returns {String}
     */
    getDirectoryType() {
      
      return 'Dossier';
    },

    /**
   * Check file extension (image or no)
   * @param extension
   * @returns {boolean}
   */
    thisImage(extension) {
      // extension not found
      if (!extension) return false;

      return this.imageExtensions.includes(extension.toLowerCase());
    },

    /**
     * Check the level of an item
     * @param path
     * @returns {Int}
     */
    getItemLevel(path) {
      return (path).toString().split("/").length; 
    },
  },
};
</script>

<style lang="scss">
thead {
    background-color: #f1f5fa;
  }
  th {
    cursor: pointer;
  }
  .active-row {
    background-color: #e3f1fd;         
  }
  tr .active:hover {
    background-color: #e3f1fd;
  }
  .table-row {
    .share-button {
      float: right;
      display: none;
      margin-right: 30px;
    }
    &:hover {
      background-color: #f2f8fd;
      // .share-button {
      //   display: inline-block;
      // }
      .item-name {
        color: #5360d4;
          text-decoration: underline;
      }
    }
  }
</style>
